<template>
  <div class="reg-wrap">
    <div v-if="regComplete" id="finish_reg">
      <div class="icon">
        <img src="../../images/reg-complete-icon.png" alt="-">
      </div>
      <h3 class="form-title">{{ $t('Registration') }}<br> {{ $t('complete') }}!</h3>
      <p>{{ $t('Thank you for registering') }}.<br>{{ $t('Please verify your account') }}.<br>
        {{ $t('An email has been sent to') }}<br>
        <a href="#">{{ formSignUp.email }}</a> {{ $t('with a link to') }}<br>
        {{ $t('verify your email address and create') }}<br> {{ $t('your account') }}.
      </p>
      <!--      <div class="form-actions alt text-center">-->
      <!--        <button class="button primary" @click="$emit('backToLogin')">Back to Login</button>-->
      <!--      </div>-->
      <div class="mt-resend">
        <span>{{ $t('Didn\'t receive a verification email?') }} </span> <span v-if="resendSuccess"
                                                                              class="success-icon"
                                                                              style="display:inline-block;vertical-align:middle;margin-left:8px;">
                          <svg width="24"
                               height="24"
                               viewBox="0 0 48 48"
                               fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <circle cx="24" cy="24" r="24" fill="#740B99"/>
                            <path d="M34 18L22 30L14 22"
                                  stroke="#fff"
                                  stroke-width="3"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>
                          </svg>
                        </span> <a v-else
                                   @click="autoResend"
                                   :style="'color:#740B99;cursor:pointer;font-weight:600;margin-left:8px;text-decoration:none;'">
        {{ resendLoading ? $t('Sending...') : $t('Resend') }} </a>
      </div>
    </div>
    <form v-if="!regComplete" v-on:submit.prevent="signUp" id="dsp-signup-form">
      <div class="step1">
        <div :class="{ 'has-error' : errors.has('formSignUp.fName') }"
             ref="fNameFormGroup"
             class="input-wrapper form-group">
          <label class="form-control-placeholder"> {{ $t('First Name') }} <span>*</span></label>
          <input v-model.trim="formSignUp.fName"
                 v-validate="'required|alpha|min:2'"
                 :data-vv-as="$t('First Name')"
                 class="form-control form-control-solid"
                 name="formSignUp.fName"
                 type="text"
                 maxlength="20"> <span v-show="errors.has('formSignUp.fName')"
                                       id="signUp-fName-tooltip"
                                       class="help-block alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip" target="signUp-fName-tooltip" placement="top">
            {{ errors.first('formSignUp.fName') }}
          </b-tooltip>
        </div>
        <div :class="{ 'has-error' : errors.has('formSignUp.lName') }"
             ref="lNameFormGroup"
             class="input-wrapper form-group">
          <label class="form-control-placeholder"> {{ $t('Last Name') }} <span>*</span></label>
          <input v-model.trim="formSignUp.lName"
                 v-validate="'required|alpha|min:2'"
                 :data-vv-as="$t('Last Name')"
                 class="form-control form-control-solid"
                 name="formSignUp.lName"
                 type="text"
                 maxlength="20"> <span v-show="errors.has('formSignUp.lName')"
                                       id="signUp-lName-tooltip"
                                       class="help-block alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip2" target="signUp-lName-tooltip" placement="top">
            {{ errors.first('formSignUp.lName') }}
          </b-tooltip>
        </div>
        <div :class="{ 'has-error' : errors.has('formSignUp.email') }"
             ref="emailFormGroup"
             class="input-wrapper form-group">
          <label class="form-control-placeholderl"> {{ $t('E-mail') }} <span>*</span></label>
          <input v-model.trim="formSignUp.email"
                 v-validate="'required|email|businessEmail|emailUnique'"
                 :data-vv-as="$t('E-mail')"
                 data-vv-delay="1000"
                 name="formSignUp.email"
                 class="form-control form-control-solid"
                 type="text"
                 maxlength="100"> <span v-show="errors.has('formSignUp.email')"
                                        id="signUp-email-tooltip"
                                        class="help-block alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip3" target="signUp-email-tooltip" placement="top">
            {{ errors.first('formSignUp.email') }}
          </b-tooltip>
        </div>
        <div class="row mobile-no-pad">
          <div class="col-md-6">
            <div :class="{ 'has-error' : errors.has('formSignUp.pass') }"
                 ref="passFormGroup"
                 class="input-wrapper form-group">
              <label class="control-label"> {{ $t('Password') }} <span>*</span></label>
              <input v-model.trim="formSignUp.pass"
                     v-validate="'required|min:6'"
                     :data-vv-as="$t('Password')"
                     name="formSignUp.pass"
                     class="form-control placeholder-no-fix"
                     type="password"
                     maxlength="100"
                     autocomplete="off"
                     ref="formSignUp.pass"> <span v-show="errors.has('formSignUp.pass')"
                                                  id="signUp-pass-tooltip"
                                                  class="help-block alt"><span class="error-sign"></span></span>
              <b-tooltip ref="tooltip4" target="signUp-pass-tooltip" placement="top">
                {{ errors.first('formSignUp.pass') }}
              </b-tooltip>
            </div>
          </div>
          <div class="col-md-6">
            <div :class="{ 'has-error' : errors.has('formSignUp.rpass') }"
                 ref="rpassFormGroup"
                 class="input-wrapper form-group">
              <label class="control-label"> {{ $t('Confirm Password') }} <span>*</span></label>
              <input v-model.trim="formSignUp.rpass"
                     v-validate="'required|min:6|confirmed:formSignUp.pass'"
                     :data-vv-as="$t('Confirm Password')"
                     name="formSignUp.rpass"
                     class="form-control placeholder-no-fix"
                     type="password"
                     maxlength="100"
                     autocomplete="off"> <span v-show="errors.has('formSignUp.rpass')"
                                               id="signUp-rpass-tooltip"
                                               class="help-block alt"><span class="error-sign"></span></span>
              <b-tooltip ref="tooltip5" target="signUp-rpass-tooltip" placement="top">
                {{ errors.first('formSignUp.rpass') }}
              </b-tooltip>
            </div>
          </div>
        </div>


        <div :class="{ 'has-error' : errors.has('formSignUp.country') }"
             ref="countryFormGroup"
             class="input-wrapper form-group">
          <label class="control-label alt"> {{ $t('Country') }} <span>*</span></label>
          <Select2 v-model="formSignUp.country"
                   v-validate="'required'"
                   :data-vv-as="$t('Country')"
                   :options="countries"
                   :settings="{ placeholder: this.$t('Choose...') }"
                   @change="changeCountry($event)"
                   name="formSignUp.country"
                   ref="countrySelect"/>
          <span v-show="errors.has('formSignUp.country')"
                id="signUp-country-tooltip"
                class="help-block alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip6" target="signUp-country-tooltip" placement="top">
            {{ errors.first('formSignUp.country') }}
          </b-tooltip>
        </div>
        <div :class="{ 'has-error' : errors.has('formSignUp.company') }"
             ref="companyFormGroup"
             class="input-wrapper form-group">
          <label class="control-label"> {{ $t('Company') }} <span>*</span></label>
          <input v-model.trim="formSignUp.company"
                 v-validate="'required|min:3'"
                 :data-vv-as="$t('Company')"
                 name="formSignUp.company"
                 class="form-control placeholder-no-fix"
                 type="text"
                 maxlength="50"> <span v-show="errors.has('formSignUp.company')"
                                       id="signUp-company-tooltip"
                                       class="help-block alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip7" target="signUp-company-tooltip" placement="top">
            {{ errors.first('formSignUp.company') }}
          </b-tooltip>
        </div>
        <div :class="{ 'has-error' : errors.has('formSignUp.phone') }" ref="phoneFormGroup" class="form-group">
          <label class="control-label alt"> {{ $t('Phone') }}</label>
          <vue-tel-input v-model.trim="formSignUp.phone"
                         v-if="telShow"
                         v-bind="bindProps"
                         v-validate="'phoneNumber|min:5'"
                         :data-vv-as="$t('Phone')"
                         @onInput="onInput"
                         name="formSignUp.phone"
                         class="country-phones"></vue-tel-input>
          <span v-show="errors.has('formSignUp.phone')"
                id="signUp-phone-tooltip"
                class="help-block alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip8" target="signUp-phone-tooltip" placement="top">
            {{ errors.first('formSignUp.phone') }}
          </b-tooltip>
        </div>

        <div class="form-group">
          <label class="control-label alt">Additional contact</label>
          <Select2 v-model="formSignUp.additionalContactType"
                   :options="additionalContactOptions"
                   :settings="{ placeholder: 'Select type...', width: '100%', allowClear: false, minimumResultsForSearch: Infinity }"
                   name="formSignUp.additionalContactType"
                   @change="onAdditionalContactTypeChange"
                   ref="additionalContactSelect"/>
        </div>

        <div v-if="formSignUp.additionalContactType === 'email'"
             :class="{ 'has-error' : errors.has('formSignUp.additionalContactValue') }"
             ref="additionalContactEmailFormGroup"
             class="input-wrapper form-group">
          <label class="form-control-placeholderl"> {{ $t('Alternative Email') }}</label>
          <input v-model.trim="formSignUp.additionalContactValue"
                 v-validate="'email|businessEmail'"
                 :data-vv-as="$t('Alternative Email')"
                 data-vv-delay="1000"
                 name="formSignUp.additionalContactValue"
                 class="form-control form-control-solid"
                 type="text"
                 maxlength="100">
          <span class="help-block">You can add your username, link, used id,  number depending on the type.</span>
          <span v-show="errors.has('formSignUp.additionalContactValue')"
                id="signUp-additionalContactValue-tooltip"
                class="help-block alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip11" target="signUp-additionalContactValue-tooltip" placement="top">
            {{ errors.first('formSignUp.additionalContactValue') }}
          </b-tooltip>


        </div>
        <div v-else-if="formSignUp.additionalContactType" class="input-wrapper form-group">
          <label class="control-label">{{ additionalPlaceholder }}</label>
          <input v-model.trim="formSignUp.additionalContactValue"
                 class="form-control placeholder-no-fix"
                 type="text"
                 maxlength="100"
                 autocomplete="off">
          <span class="help-block">You can add your username, link, used id,  number depending on the type.</span>

        </div>
        <div :class="{ 'has-error' : !reCaptcha.verify }" ref="recaptchaFormGroup" class="form-group">
          <div>
            <vue-recaptcha ref="recaptcha"
                           :sitekey="reCaptcha.siteKey"
                           @verify="onCaptchaVerify"
                           @expired="onCaptchaExpired"/>
          </div>
          <span v-if="!reCaptcha.verify"
                id="signUp-сaptcha-tooltip"
                class="help-block alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip9" target="signUp-сaptcha-tooltip" placement="top">
            {{ $t('Please, confirm that you are not a robot.') }}
          </b-tooltip>
        </div>
        <div :class="{ 'has-error' : errors.has('formSignUp.terms') }" ref="termsFormGroup" class="form-group agree">
          <input v-model="formSignUp.terms"
                 v-validate="'required'"
                 :data-vv-as="$t('I agree to the')"
                 type="checkbox"
                 name="formSignUp.terms"
                 id="agree"
                 value="on"> <label class="alt rem" for="agree">
                        <span class="terms-link">
                            I have read and agree to the
                        </span>&nbsp; <span class="terms-link">
                            <a href="https://smartyads.com/terms-of-service"
                               target="_blank"
                               data-page="termofservice"
                               data-pagetitle="Terms of service"> {{ $t('Terms of service') }}</a>

                        </span>

        </label> <span v-show="errors.has('formSignUp.terms')"
                       id="signUp-terms-tooltip"
                       class="help-block norm alt"><span class="error-sign"></span></span>
          <b-tooltip ref="tooltip10" target="signUp-terms-tooltip" placement="top">
            {{ errors.first('formSignUp.terms') }}
          </b-tooltip>
        </div>
      </div>
      <div class="form-actions text-center">
        <button :disabled="registerButtonDisabled" class="button primary w-100">{{ $t('Register') }}
        </button>
      </div>
      <div class="form-group  text-center">
        <span class="terms-link">By logging in/registering an account, you acknowledge that your personal data will be processed in accordance with our  </span>
        <span class="terms-link"><a href="https://smartyads.com/services-privacy-policy"
                                    target="_blank">Services Privacy Policy</a>.
                                        </span>
      </div>
      <div class="copyrights">2011-2025 &copy; SmartyAds. All Rights Reserved</div>
    </form>
  </div>
</template>

<script>

import VueTelInput from 'vue-tel-input';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'signup',
  components: {
    VueTelInput,
    VueRecaptcha,
  },
  inject: ['sendGTag'],
  data: function () {
    return {
      resendLoading: false,
      resendSuccess: false,
      formHasErrors: true,
      regComplete: false,
      countries: [], // or [{id: key, text: value}, {id: key, text: value}]
      reCaptcha: {
        siteKey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
        verify: false,
      },
      additionalContactOptions: [
        {id: 'whatsapp', text: 'WhatsApp'},
        {id: 'telegram', text: 'Telegram'},
        {id: 'wechat', text: 'WeChat'},
        {id: 'linkedin', text: 'LinkedIn'},
        {id: 'email', text: 'Alternative Email'},
        {id: 'other', text: 'Other'},
      ],
      telShow: true,
      bindProps: {
        defaultCountry: '',
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: this.$t('Enter a phone number'),
        required: false,
        enabledCountryCode: false,
        enabledFlags: true,
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: 'off',
        name: 'telephone',
        maxLen: 25,
        wrapperClasses: '',
        inputClasses: '',
        dropdownOptions: {
          disabledDialCode: false
        },
        inputOptions: {
          showDialCode: true
        }
      },
      formSignUp: {
        fName: '',
        lName: '',
        email: '',
        pass: '',
        rpass: '',
        country: '',
        company: '',
        phone: '',
        additionalContactType: '',
        additionalContactValue: '',
        terms: false,
        recaptcha: '',
      },
      isValidPhone: false
    };
  },
  computed: {
    registerButtonDisabled() {
      // Disabled if recaptcha not valid
      if (!this.reCaptcha.verify) {
        return true;
      }

      // Disabled if exists validation errors
      if (this.errors.count() !== 0) {
        return true;
      }

      // Disabled if exists empty fields with required validation rule
      const requiredEmptyFields = this.$validator.fields.map(item => item)
        .filter((item => item.rules.required !== undefined && !item.value))
        .map(item => item);
      if (requiredEmptyFields.length > 0) {
        return true;
      }

      // Enabled
      return false;
    },
    additionalPlaceholder() {
      switch (this.formSignUp.additionalContactType) {
        case 'whatsapp':
          return 'WhatsApp';
        case ' ':
          return 'Telegram';
        case 'wechat':
          return 'WeChat';
        case 'linkedin':
          return 'LinkedIn URL';
        case 'email':
          return 'Alternative email';
        default:
          return 'Contact detail';
      }
    },
  },
  created() {
    this.setCountryByIp();
    if (this.additionalContactOptions && Array.isArray(this.additionalContactOptions)) {
      this.additionalContactOptions = this.additionalContactOptions.map((row) => {
        if (Array.isArray(row)) {
          row.id = row[0];
          row.text = row[1];
        }
        return row;
      });
    }
    this.$validator.localize('en', {
      attributes: {
        'formSignUp.fName': 'First Name',
        'formSignUp.lName': 'Last Name',
        'formSignUp.email': 'Email',
        'formSignUp.pass': 'Password',
        'formSignUp.rpass': 'Confirm Password',
        'formSignUp.country': 'Country',
        'formSignUp.company': 'Company',
        'formSignUp.phone': 'Phone',
        'formSignUp.terms': 'Terms',
      },
      custom: {
        formSignUp: {
          fName: {
            required: 'Please enter your First Name.',
            alpha: 'Only latin letters.',
            min: 'Must be at least 3 characters long.',
          },
          lName: {
            required: 'Please enter your Last Name.',
            alpha: 'Only latin letters.',
            min: 'Must be at least 3 characters long.',
          },
          email: {
            required: 'Please enter a valid email address (e.g. john@site.com).',
            email: 'Please enter a valid email address (e.g. john@site.com).',
            businessEmail: 'Your email is hosted on public mail servers or does not exist.',
            emailUnique: 'This Email address already associates with another account.',
          },
          pass: {
            required: 'Must be at least 6 characters long.',
            min: 'Must be at least 6 characters long.',
          },
          rpass: {
            required: 'Must be at least 6 characters long.',
            min: 'Must be at least 6 characters long.',
            confirmed: 'The passwords you entered do not match. Please re-enter your password.',
          },
          country: {
            required: 'Please select your Country.',
          },
          company: {
            required: 'Please enter your Company name.',
          },
          terms: {
            required: 'Please check this box if you want to proceed.',
          },
        },

        /*'formSignUp.phone': {
            phoneNumber: "Special characters and letters are not allowed.",
            min: "Must be at least 5 digits.",
        },*/

      }
    });
    this.$validator.extend('businessEmail', {
      validate: (value) => {

        if (process.env.VUE_APP_ENV !== 'production') {
          return true;
        }

        if (['ads@digital.neuelt.com', 'ihor.advert@meta.ua'].includes(value)) {
          return true;
        }

        let reg = new RegExp(/^([\w-.]+@(?!abc\.com)(?!protectsmail\.)(?![a-z0-9]+\.ru$)(?!aol\.com)(?!gmail\.com)(?!hotmail\.com)(?!live\.com)(?!me\.com)(?!msn\.com)(?!mail\.ru)(?!outlook\.com)(?!pqr\.com)(?!protonmail\.com)(?!qq\.com)(?!rediffmail\.com)(?!ukr\.net)(?!xyz\.com)(?!yahoo\.com)(?!yahoo\.co\.in)(?!yandex\.ru)(?!ymail\.com)(?!trashmail\.win)(?!dispomail\.xyz)(?!fakemail\.top)(?!xxxxx\.cyou)([\w-]+\.)+[\w-]{2,10})?$/, 'ig');
        if (reg.test(value)) {
          return true;
        }
        return false;
      }
    });
    this.$validator.extend('emailUnique', {
      validate: async (value) => {
        let emailIsUnique = true;
        await this.$axios.post('/users/check-email', {email: value}).then((response) => {
          emailIsUnique = !response.data.emailAlreadyExists;
        });
        return emailIsUnique;
      }
    });
    this.$validator.extend('phoneNumber', {
      validate: () => {
        //validate letter
        if (!this.isValidPhone) {
          return false;
        }
        //validate spesial chars
        /*if (value.match(/[\!\@\#\$\%\^\&\*\-\=\"\№\;\:\?\_\,\.\/\\\{\}\[\]\|]/)) {
            return false;
        }*/
        return true;
      }
    });

  },
  mounted: function () {
    this.getCountries();

    try {
      let self = this;
      this.$refs.countrySelect.$el.getElementsByTagName('select')[0].addEventListener('change', function (event) {
        self.formSignUp.country = event.target.value;
      });
      this.$refs.additionalContactSelect.$el.getElementsByTagName('select')[0].addEventListener('change', function (event) {
        self.formSignUp.additionalContactType = event.target.value;
      });
    } catch (e) {
      // Костыль автозаполнение выбора стран
    }

    //console.log(this.bindProps.defaultCountry);
  },
  methods: {
    async autoResend() {
      this.resendLoading = true;
      try {
        this.resendSuccess = true;
        await this.$axios.post('users/resendVerification', {email: this.formSignUp.email});
        this.$notify.info(this.$t('Verification email sent!'));
        if (this.resendTimer) clearTimeout(this.resendTimer);
        this.resendTimer = setTimeout(() => {
          this.resendSuccess = false;
        }, 60000);
      } catch (e) {
        this.$notify.error(this.$t('Failed to send verification email'));
      } finally {
        this.resendLoading = false;
      }
    },
    changeCountry(countryCode) {
      this.bindProps.defaultCountry = countryCode;
      this.telShow = false;
      this.$nextTick(() => {
        this.telShow = true;
      });
    }, // eslint-disable-next-line
    onInput({
              // eslint-disable-next-line no-unused-vars
              number,
              isValid, // eslint-disable-next-line no-unused-vars
              country
            }) {
      this.isValidPhone = isValid;
    },
    onAdditionalContactTypeChange() {
      this.formSignUp.additionalContactValue = '';
    },
    setCountryByIp() {
      this.$axios
        .post('/dictionary/getCountryUser')
        .then(response => {
          if (response.data.length > 1) {
            this.bindProps.defaultCountry = response.data;
            this.telShow = false;
            this.$nextTick(() => {
              this.telShow = true;
            });

            return;
          }

          this.$axios
            .post('https://extreme-ip-lookup.com/json/')
            .then(response => {
              this.bindProps.defaultCountry = response.data.countryCode;
              this.telShow = false;
              this.$nextTick(() => {
                this.telShow = true;
              });
            });

        });
    },
    onOpenTooltip() {
      this.$refs.tooltip.$emit('open');
      this.$refs.tooltip2.$emit('open');
      this.$refs.tooltip3.$emit('open');
      this.$refs.tooltip4.$emit('open');
      this.$refs.tooltip5.$emit('open');
      this.$refs.tooltip6.$emit('open');
      this.$refs.tooltip7.$emit('open');
      this.$refs.tooltip8.$emit('open');
      //this.$refs.tooltip9.$emit('open');
      this.$refs.tooltip10.$emit('open');
    },
    onCloseTooltip() {
      this.$refs.tooltip.$emit('close');
      this.$refs.tooltip2.$emit('close');
      this.$refs.tooltip3.$emit('close');
      this.$refs.tooltip4.$emit('close');
      this.$refs.tooltip5.$emit('close');
      this.$refs.tooltip6.$emit('close');
      this.$refs.tooltip7.$emit('close');
      this.$refs.tooltip8.$emit('close');
      //this.$refs.tooltip9.$emit('close');
      this.$refs.tooltip10.$emit('close');
    },
    onCaptchaVerify(recaptchaToken) {
      this.formSignUp.recaptcha = recaptchaToken;
      this.reCaptcha.verify = true;
    },
    onCaptchaExpired() {
      this.formSignUp.recaptcha = '';
      this.reCaptcha.verify = false;
      this.$refs.recaptcha.reset();
    },
    getCountries() {
      this.$axios
        .post('/dictionary/countries', {
          locale: 'en',
        })
        .then(response => {
          let countries = response.data;
          if (!countries) return false;
          let countriesArr = Object.entries(countries);
          if (countriesArr) {
            this.countries = countriesArr.map((row) => {
              row.id = row[0];
              row.text = row[1];
              return row;
            });
          }
        });
    },
    sendToHubSpot(params) {
      if (process.env.VUE_APP_ENV !== 'production') {
        return;
      }
      const url = 'https://api.hsforms.com/submissions/v3/integration/submit/2993981/0a7aaa64-79aa-4e56-95e8-3b903a7ec41c';
      let data = {
        'submittedAt': +(new Date),
        'fields': [{
          'name': 'email',
          'value': params.email,
        }, {
          'name': 'firstname',
          'value': params.firstName,
        }, {
          'name': 'lastname',
          'value': params.lastName,
        }, {
          'name': 'company',
          'value': params.company,
        }, {
          'name': 'phone',
          'value': params.phone,
        }],
        'context': {
          'hutk': this.$cookies.get('hubspotutk'),
          'pageUri': 'https://dsp.smartyads.com/signin',
          'pageName': 'SmartyAds DSP'
        },
      };
      this.$axios.post(url, data);
    },
    signUp() {
      this.$validator.validateAll().then(valid => {
        /*this.onCloseTooltip();
        this.onOpenTooltip();*/

        //console.log('ERRORS_ALL', this.errors.all());

        if (!valid) {
          let errorFields = this.$validator.errors.items.map(item => item.field.replace('formSignUp.', ''));
          if (errorFields.length === 0) {
            return false;
          }

          let allFieldsSorted = ['fName', 'lName', 'email', 'pass', 'rpass', 'country', 'company', 'phone', 'recaptcha', 'terms'];
          let errorFieldsSorted = allFieldsSorted.filter(field => errorFields.includes(field));
          let refName = errorFieldsSorted[0] + 'FormGroup';
          if (this.$refs[refName] === undefined) {
            return false;
          }

          this.$refs[refName].scrollIntoView();

          return false;
        }

        let allParams = {
          firstName: this.formSignUp.fName,
          lastName: this.formSignUp.lName,
          email: this.formSignUp.email,
          password: this.formSignUp.pass,
          password_confirmation: this.formSignUp.rpass,
          country: this.formSignUp.country,
          company: this.formSignUp.company,
          recaptcha: this.formSignUp.recaptcha,
          hubspotutk: this.$cookies.get('hubspotutk') ? this.$cookies.get('hubspotutk') : 'empty',
          additionalContactType: this.formSignUp.additionalContactType,
          additionalContactValue: this.formSignUp.additionalContactValue,
        };

        if (this.formSignUp.phone) {
          allParams.phone = this.formSignUp.phone;
        }
        if (!this.reCaptcha.verify) {
          return false;
        }
        this.$auth.register({
          context: this,
          params: allParams,
          success: function (resp) {
            this.regComplete = true;
            this.sendGTag('sign_up', 'dsp-agree');
            if (window.dataLayer) {
              window.dataLayer.push({
                'event': 'sign_up_dsp',
                'firstName': this.formSignUp.firstName,
                'lastName': this.formSignUp.lastName,
                'email': this.formSignUp.email,
                'phone': this.formSignUp.phone,
                'company': this.formSignUp.company,
                'country': this.formSignUp.country,
                'userid': resp.data.userId,
              });
            }

            return false;
          },
          error: function (error) {
            this.$backendErrors(error, 'Registration error: ', this.$validator, 'formSignUp.');
          },
        });
      });
    },
  }

};
</script>
<style lang="scss">
@import "../../scss/components/checkboxlogin";
@import '~vue-tel-input/dist/vue-tel-input.css';

.step1 .form-group {
  margin-bottom: 20px !important;
}

.copyrights {
  text-align: center;
  font-size: 12px;
}

.mt-resend {
  margin-top: 50px;
}

@media (max-width: 1100px) {
  .mobile-no-pad {
    margin-right: -15px !important;
    margin-left: -15px !important;
  }
}

::v-deep .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #333 !important;
}

::v-deep .select2-container .select2-selection--single {
  height: 38px;
  display: flex;
  align-items: center;
}
.terms-link {
  font-size: 12px;
  line-height: 1.5;
}
</style>
